// ©2024 Austin App House. All rights reserved.
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { exportWorkOrders } from '../../../storage/actions/workOrdersActions';
import prepareFilters from '../../../utils/prepareFilters';
import { getStatus } from '../../../utils/api/get/getWorkOrders';

const WorkOrderButtonControl = ({
  selectedWorkOrders, userType, exportWorkOrders,
  search, filters, activeTab,
}) => {
  const requestData = useMemo(() => {
    const base = selectedWorkOrders.length
      ? { workOrdersId: selectedWorkOrders }
      : {
        ...search,
        filters: prepareFilters(filters),
      };
    return { ...base, ...getStatus(activeTab) };
  }, [selectedWorkOrders, search, filters, activeTab]);

  const showExport = (
    activeTab === 'upcoming-work'
    || activeTab === 'completed'
    || activeTab === 'approved'
    || activeTab === 'paid'
  ) && activeTab !== 'routed';

  if (!showExport) return null;

  return (
    <div className="action-buttons">
      <button
        className="dashboard-btn dashboard-btn--export"
        type="button"
        onClick={() => exportWorkOrders(requestData, userType)}
      >
        Export Excel
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  exportWorkOrders,
};

const mapStateToProps = state => ({
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  activeTab: state.applicationState.activeTab,
  search: state.workOrder.searchData,
  filters: state.workOrder.filters,
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderButtonControl);
